import { render } from "./App.vue?vue&type=template&id=6b64c6c1&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6b64c6c1&scoped=true&lang=css"

import exportComponent from "E:\\www\\xh\\kancnpay\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b64c6c1"]])

export default __exports__